import { render, staticRenderFns } from "./AvatarListCell.vue?vue&type=template&id=395310c5"
import script from "./AvatarListCell.vue?vue&type=script&lang=js"
export * from "./AvatarListCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports